define('viewmodels/notifications',['knockout', 'underscore'], function (ko, _) {

    var NotificationsViewModel = function(session, actionProvider, getField, dialog, NotificationsDialog, gameLauncher) {
        var self = this,
            player = session.getAssociatedPlayer;

        self.actionProvider = actionProvider;

        self.forceHideNotifications = ko.observable(true);

        self.commonNotifications = player.property('notifications');

        self.notifications = self.commonNotifications.property('pendingNotifications');

        self.notificationsCount = self.notifications.len();

        self.hasNotifications = self.notifications.any();

        self.hasMultipleNotifications = self.notifications.many();

        self.showingAllNotifications = ko.observable(false);

        self.containsAlerts = self.notifications.some(function(notification) {
            return notification.notification.feedbackType() === 'alert';
        });

        self.showNotifications = ko.deferredComputed(function () {
            return !self.forceHideNotifications() && self.hasNotifications() && !self.showingAllNotifications() && !gameLauncher.hasActiveGameRunner();
        });

        self.multipleNotificationsMessage = getField('multiple_notifications_message', {
            count: self.notificationsCount
        });
        self.allNotificationsDialogTitle = getField('all_notifications_title');

        // we mark all notifications as dismissed if they are ignored for 7 seconds
        self.notificationsCount.subscribeAndExec(function (count) {

            window.clearTimeout(self.dismissNotificationsTimeout);

            if (count > 0) {
                self.dismissNotificationsTimeout = window.setTimeout(function() {

                    if (!gameLauncher.hasActiveGameRunner()) {
                        self.dismissNotifications();
                    }
                }, 7000);
            }
        });

        self.showAll = function() {
            self.showingAllNotifications(true);
            dialog.showDialog(new NotificationsDialog(getField('all_notifications_title'), self.notifications)).then(function() {
                self.showingAllNotifications(false);
                self.dismissNotifications();
            });
        };

        self.getTitle = function(notification) {
            if (notification.type === 'ITEM_EARNED' || notification.type === 'GEM_EARNED') {
                return getField('item_received_text', notification.notification);
            } else if (notification.type === 'ACHIEVEMENT_EARNED') {
                return getField('achievement_received_text', notification.notification);
            } else {
                return notification.notification.title;
            }
        };
    };

    NotificationsViewModel.prototype.compositionComplete = function() {
        var self = this;
        window.setTimeout(function() {
            self.forceHideNotifications(false);
        }, 1000);
    };

    NotificationsViewModel.prototype.doAction = function(notification, action) {
        var self = this;

        window.clearTimeout(self.dismissNotificationsTimeout);

        self.actionProvider.getNotificationAction(action.action, ko.unwrap(notification.parameters))
            .onClick()
            .then(notification.markAsRead.bind(notification));
    };

    NotificationsViewModel.prototype.dismissNotifications = function() {
        var self = this;

        window.clearTimeout(self.dismissNotificationsTimeout);

        if (!self.showingAllNotifications()) {
            self.forceHideNotifications(true);

            window.setTimeout(function() {
                self.commonNotifications().markAllAsRead().then(function(){
                    self.forceHideNotifications(false);
                });
            }, 150);
        }
    };

    return NotificationsViewModel;
});

